import { IPagedQuery } from './paginate';
import * as actionTypeProfile from '../../models/action/profile';

export interface ICourseStudentListTabState {
    filters: IFilterStudent;
    filterIsOpen: boolean;
    student_list: Array<IStudentItem> | null;
    selected_ids: Array<number>;
}

export interface IPageProps {
    history?: any;
    location?: any;
    match?: any;
    dispatch?: any;
}

export const StudentSearchInitialValues: IFilterStudent = {
    orderBy: '',
    query: '',
    page: 1,
    total: -1,
    skip: 0,
    take: 10
};

export interface IStudentPageProps extends IPageProps {
    results?: Array<IStudentItem>;
    coursePageClassId?: string;
    coursePageActivityId?: string;
    filters?: IFilterStudent;
    studentList?: Array<any>;
    userPreferences?: Array<actionTypeProfile.IPreference>;
    classes?: any;
}

export interface IStudentPageState {
    filters: IFilterStudent;
    filterIsOpen: boolean;
    student_list?: Array<IStudentItem>;
    selected_ids: Array<number>;
    selectedOption: Array<{ value: number, label: string }>
    isSearchBoxOpen: boolean
}

export interface IStudentItem {
    // ALMS+ types
    userId: number | null;
    userName: string | null;
    firstName: string | null;
    lastName: string | null;
    lastLoginDate: string | null;
    avatarPath: string | null;
    progress: string | null;
}

export interface IFilterStudent extends IPagedQuery {
    take: number;
    page: number;
    total: number;
    skip: number;
    orderBy: string | undefined;
}
